import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { filter, map, pipe } from 'rxjs';

import { breakFeatureKey, BreakState } from './break.reducer';

export const selectBreakState = createFeatureSelector<BreakState>(breakFeatureKey);

export const selectBreakDialogContext = createSelector(selectBreakState, (state) => state.dialogContext);

export const selectBreakIfLoaded = pipe(
    select(selectBreakState),
    filter((state) => state.loadFromStorageProgress.done),
    map((state) => state.break),
);

export const selectIsOnBreakIfLoaded = pipe(
    selectBreakIfLoaded,
    map((breakData) => !!breakData),
);
